import React from "react";
import { useTranslation } from "react-i18next";
import { createRoot } from "react-dom/client";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

// Core function that shows the dialog and returns a Promise<boolean>
export default function showQuestion(question: string, title?: string): Promise<boolean> {
    return new Promise((resolve) => {
        const container = document.createElement("div");
        document.body.appendChild(container);

        const handleClose = (answer: boolean) => {
        root.unmount();
        container.remove();
        resolve(answer);
        };

        const DialogComponent: React.FC = () => {
            const { t } = useTranslation();

            return (
                <Dialog open onClose={() => handleClose(false)}>
                <DialogTitle>{title || t("dialog.confirm")}</DialogTitle>
                <DialogContent>{question}</DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose(false)}>{t("button.no")}</Button>
                    <Button onClick={() => handleClose(true)} variant="contained">
                    {t("button.yes")}
                    </Button>
                </DialogActions>
                </Dialog>
            );
        };

        const root = createRoot(container);
        root.render(<DialogComponent />);
    });
}
